import { safeJsonParse } from "@/zapi-frontend/utils/safeJsonParse";

export const processAssistantResponse = async ({
  messageContent,
  targetProjectId,
  targetChapterId,
  invalidateChapterCroppedImages,
  chapterContent,
  createPendingChanges
}: {
  messageContent: string;
  targetProjectId: string;
  targetChapterId: string;
  invalidateChapterCroppedImages: (chapterId: string) => Promise<void>;
  chapterContent: string;
  createPendingChanges: (projectId: string, chapterId: string, newContent: string, oldContent: string) => void;
}) => {
  console.log("Parsing message content");
  const parsed = safeJsonParse(messageContent);
  console.log("Parsed message content");
  if ((parsed.type === "updateChapter" || parsed.type === "memo") && parsed.content) {
    const imageRegex = /!\[.*?\]\(.*?\)/g;
    console.log("Image regex test", imageRegex.test(parsed.content));
    if (imageRegex.test(parsed.content)) {
      try {
        await invalidateChapterCroppedImages(targetChapterId);
      } catch (error) {
        console.error("Failed to invalidate chapter cropped images:", error);
      }
    }
    console.log("Creating pending changes");
    createPendingChanges(targetProjectId, targetChapterId, parsed.content, chapterContent);
    console.log("Pending changes created");
  }
};
